export default {"src":"/_next/static/media/moonbeam-explorer.61fb566c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};